module.exports = "<p>\n  object-field-templates works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/settings/object-field-templates/object-field-templates.component.html
// module id = ./src/app/settings/object-field-templates/object-field-templates.component.html
// module chunks = main